import React, { useState } from "react";

import "./styles.scss";

const DropdownSearch = ({
  label,
  placeholder,
  items,
  onChange,
  selectedItem,
  noWrapper,
  labelNoWrapper,
  defaultValue,
  onSearch,
}) => {
  const [isOpen, setOpen] = useState(false);

  const toggleDropdown = () => setOpen(!isOpen);

  return (
    <div className="dropdown">
      <label>{label}</label>
      {labelNoWrapper && <p className="dropdown-labelNoWrapper">{labelNoWrapper}</p>}
      <div
        className={noWrapper ? "dropdown-header-no-wrapper" : "dropdown-header"}
        onClick={toggleDropdown}
      >
        {selectedItem ? (
          items.find((item) => item.value === selectedItem).label
        ) : defaultValue ? (
          <>
            <span>{defaultValue}</span>
          </>
        ) : (
          <>
            <span className="dropdown-header__placeholder">{placeholder}</span>
          </>
        )}

        <svg
          className={`icon ${isOpen && "open"}`}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 9L12 15L6 9"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className={`dropdown-body ${isOpen && "open"}`}>
        <input onChange={onSearch} placeholder="Cari"></input>
        {items ? (
          items.map((item, i) => (
            <div
              className="dropdown-item"
              onClick={() => {
                toggleDropdown();
                onChange(item.value, item.label);
              }}
              id={item.value}
              key={i}
            >
              <span className={`dropdown-item-dot ${item.value === selectedItem && "selected"}`}>
                •{" "}
              </span>
              {item.label}
            </div>
          ))
        ) : (
          <span>Empty data</span>
        )}
      </div>
    </div>
  );
};

export default DropdownSearch;
